import React, { useState } from 'react';
import { 
  Box, 
  Card, 
  CardContent,
  Divider,
  Grid,
  Typography,
  Avatar,
  Chip,
  useTheme
} from '@mui/material';
import { 
  PeopleAlt as UsersIcon,
  TrendingUp as TrendingUpIcon,
  Timeline as TimelineIcon
} from '@mui/icons-material';


const UserStatsComponent = ({
  title = "",
 
  layout = "horizontal",
  onStatClick = () => {},
  elevation = 1,
  borderRadius = 1,
  compact = true,
  usersSummary,
}) => {
  const [hoveredStat, setHoveredStat] = useState(null);
  const theme = useTheme();
  const defaultStats = [
    { 
      id: 'total-users', 
      label: 'Total Users', 
      value: usersSummary?.totalUser || 0, 
      icon: <UsersIcon fontSize="small" />, 
      trend: 'up',
      color: 'primary.main'
    },
    { 
      id: 'active-users', 
      label: 'Active Users', 
      value: usersSummary?.totalVerifiedUser || 0, 
      icon: <TrendingUpIcon fontSize="small" />, 
      change: '+7%', 
      trend: 'up',
      color: 'secondary.main'
    },
    { 
      id: 'growth-rate', 
      label: 'Limit', 
      value: `${usersSummary?.totalUser } / ${usersSummary?.maxLimit || 0}`, 
      icon: <TimelineIcon fontSize="small" />, 
      change: ` ${usersSummary?.maxLimit - usersSummary?.totalUser} left`, 
      trend: 'up',
      color: 'info.main'
    }
  ];
  let stats = defaultStats;
  return (
    <Card 
      elevation={elevation} 
      sx={{ 
        margin: '0 auto',
        marginBottom:2,
        borderRadius: borderRadius,
        overflow: 'visible',
        transition: 'all 0.2s ease',
        bgcolor:'black',
        borderRadius: '1.5em',
        padding: '0.1em',
        margintTop:10,
      }}
    >
      <CardContent sx={{ pt: 2, px: 2, pb: 0 }}>
        <Typography 
          variant="subtitle1" 
          component="h3" 
          sx={{ 
            mb: 2, 
            fontWeight: 600, 
            color: 'text.primary',
          }}
        >
          {title}
        </Typography>

        <Grid 
          container 
          spacing={compact ? 1 : 2} 
          sx={{ mb: 1 }}
        >
          {stats.map((stat, index) => {
            const isHovered = hoveredStat === index;
            
            return (
              <Grid 
                item 
                xs={12} 
                md={4} 
                key={stat.id || index}
                sx={{ 
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <Box 
                  sx={{ 
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    p: compact ? 1 : 2,
                    borderRadius: theme.shape.borderRadius,
                    transition: 'all 0.2s ease',
                    transform: isHovered ? 'translateY(-2px)' : 'none',
                    boxShadow: isHovered ? theme.shadows[2] : 'none',
                    position: 'relative',
                    cursor: 'pointer',
                    ...(layout === 'horizontal' && {
                      borderRight: index !== stats.length - 1 ? `1px solid ${theme.palette.divider}` : 'none',
                    })
                  }}
                  onMouseEnter={() => setHoveredStat(index)}
                  onMouseLeave={() => setHoveredStat(null)}
                  onClick={() => onStatClick(stat)}
                >
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    mb: 1 
                  }}>
                    <Avatar
                      sx={{ 
                        mr: 1.5, 
                        bgcolor: stat.color || 'primary.main',
                        width: 32,
                        height: 32,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.05)'
                      }}
                    >
                      {stat.icon}
                    </Avatar>
                    <Typography 
                      variant="body2" 
                      color="text.secondary"
                      sx={{ fontWeight: 500 }}
                    >
                      {stat.label}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ 
                    display: 'flex', 
                    alignItems: 'baseline',
                    mt: 'auto'
                  }}>
                    <Typography 
                      variant={compact ? "h5" : "h4"} 
                      component="div" 
                      sx={{ 
                        fontWeight: 700, 
                        mr: 1,
                        color: 'text.primary',
                      }}
                    >
                      {stat.value}
                    </Typography>
                    
                    {stat.change &&<Chip
                      size="small"
                      label={stat.change}
                      color={stat.trend === 'up' ? 'success' : 'error'}
                      sx={{ 
                        height: 20,
                        fontWeight: 500,
                        '& .MuiChip-label': { px: 1, py: 0, fontSize: '0.75rem' }
                      }}
                    /> }
                  </Box>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </CardContent>
      
      

    </Card>
  );
};

export default UserStatsComponent;